import Relay from 'react-relay';

export default class AddReviewLinkMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{addReviewLink}`;
  }

  getVariables() {
    return {
      conversationId: this.props.conversationId,
      linkToReview: this.props.linkToReview
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on addReviewLinkPayload {
        conversation {
          linkToReview
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        conversation: this.props.conversationRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/AddReviewLinkMutation.js
 **/